import React from "react";
import { useTranslation } from "react-i18next";

import flandersImg from "../../../../assets/flanders.jpg";
import gironaImg from "../../../../assets/girona.jpg";

// NOTE: this component also relies on .select-service__title / .select-service__divider,
// which are defined in SelectService.css and are NOT imported here.
// They are only available because the parent (SelectService.jsx) imports that file.
// If this component is ever rendered outside of SelectService, those styles will be missing.
import "./SelectRegion.css";

function RegionCard({ image, tag, title, description, onContinue, t }) {
  return (
    <div className="region-card">
      <img src={image} alt={tag} className="region-card__image" />
      <div className="region-card__body">
        <span className="region-card__tag">{tag}</span>
        <h3 className="region-card__title">{title}</h3>
        <p className="region-card__description">{description}</p>
        <button type="button" className="region-card__button" onClick={onContinue}>
          {t("continue")}
        </button>
      </div>
    </div>
  );
}

export default function SelectRegion({ onContinue }) {
  const { t } = useTranslation("select-service", {
    keyPrefix: "selectRegion"
  });

  return (
    <div>
      <h1 className="select-service__title">{t("title")}</h1>
      <hr className="select-service__divider" />
      <div className="select-region__cards">

        <RegionCard
          image={flandersImg}
          tag={t("regions.flanders.tag")}
          title={t("regions.flanders.title")}
          description={t("regions.flanders.description")}
          onContinue={() => onContinue("flanders")}
          t={t}
        />

        <RegionCard
          image={gironaImg}
          tag={t("regions.girona.tag")}
          title={t("regions.girona.title")}
          description={t("regions.girona.description")}
          onContinue={() => onContinue("girona")}
          t={t}
        />

      </div>
    </div>
  );
}